import React from 'react'
import { Grid, Typography } from '@mui/material'
import useStyles from './Styles'
import { Box } from '@mui/system'
import { ButtonComponent } from 'src/components/shared/atoms'
import { campaignsBrandGuidlinesCardI } from 'src/types/store/index'
import { useRouter } from 'next/router'
interface Props {
  zenMode: boolean
  campaignsBrandGuidlinesCard: campaignsBrandGuidlinesCardI[]
}
function Card({ zenMode, campaignsBrandGuidlinesCard }: Props) {
  const { classes } = useStyles()
  const router = useRouter()
  return (
    <div className={` ${classes.root} ${zenMode ? classes.zenMode : ''} `}>
      <Grid
        container
        spacing={{ md: 8, sm: 8, xs: 0 }}
        rowSpacing={{ md: 16, sm: 10, xs: 10 }}
        my={8}
      >
        {campaignsBrandGuidlinesCard.map((card, idx) => {
          return (
            <Grid item xs={12} sm={12} md={6} key={idx}>
              <Box
                className={`${classes.boxOne} ${
                  idx === 1 && !zenMode && classes.boxTwo
                }  ${zenMode ? classes.zenMode : ''}  `}
              >
                <Box>
                  <Typography
                    className={`${classes.title} ${
                      !zenMode && idx === 1 && classes.titleBoxTwo
                    }`}
                  >
                    {card.heading}
                  </Typography>
                  <Typography
                    className={`${classes.desc} ${
                      idx === 1 && !zenMode && classes.descBoxTwo
                    }`}
                  >
                    {card.description}
                  </Typography>
                </Box>

                <ButtonComponent
                  type="contained"
                  gradient
                  text={card.button.content}
                  onClick={() =>
                    card.button.href ? router.push(card.button.href) : ''
                  }
                  className={`${classes.cardsBtn} ${
                    idx === 1 && classes.cardsBtnBoxTwo
                  }`}
                />
              </Box>
            </Grid>
          )
        })}
      </Grid>
    </div>
  )
}

export default Card
